/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApplicationResponseBaseResponse as ModelsV4ApplicationApplicationResponseBaseResponse } from '../../models/Models/v4/Application/application-response-base-response';
import { ApplicationStartBrokerRequest as ModelsV4ApplicationApplicationStartBrokerRequest } from '../../models/Models/v4/Application/application-start-broker-request';

export interface V4ApplicationPersonalloanBrokerPost$Xml$Plain$Params {
      body?: ModelsV4ApplicationApplicationStartBrokerRequest
}

export function v4ApplicationPersonalloanBrokerPost$Xml$Plain(http: HttpClient, rootUrl: string, params?: V4ApplicationPersonalloanBrokerPost$Xml$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV4ApplicationApplicationResponseBaseResponse>> {
  const rb = new RequestBuilder(rootUrl, v4ApplicationPersonalloanBrokerPost$Xml$Plain.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+xml');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ModelsV4ApplicationApplicationResponseBaseResponse>;
    })
  );
}

v4ApplicationPersonalloanBrokerPost$Xml$Plain.PATH = '/v4/application/personalloan/broker';
